// The trader's rules (the ones in Morning prep).
import { api } from './api';

// Adds a rule unless it's already there.
export async function addRoutineRule(rule) {
  const r = await api('/routine');
  const rules = r.rules || [];
  if (!rules.some((x) => x.trim().toLowerCase() === rule.toLowerCase())) await api('/routine', { method: 'PUT', body: { rules: [...rules, rule].slice(0, 20) } });
}
